export enum ActiveTypeEnum {
  Active = 1,
  InActive = 2
}

export enum DeleteTypeEnum {
  AlreadyDelete = 1,
  NotDelete = 2
}

export enum RequestStatusEnum {
  Draft = 1,
  SentRequest = 2,
  Approved = 3,
  Reject = 4
}
